
import { useState } from 'react';
import { portfolioItems } from '../../../mocks/portfolio';

export default function Portfolio() {
  return null;
}
